import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5d813d18"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StockItemPopupTitle: require('C:/Users/USER/Desktop/infostock/front/client/components/StockItem/StockItemPopupTitle.vue').default})
